// Core
import React from "react";
import { Droppable, Draggable } from "react-beautiful-dnd";
import EditIcon from "material-ui/svg-icons/image/edit";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import CameraIcon from "material-ui/svg-icons/image/camera-alt";
import CommentIcon from "material-ui/svg-icons/editor/insert-comment";
import IconButton from "material-ui/IconButton";
import { Card } from "material-ui/Card";
import memoizeOne from 'memoize-one';

// Instruments
// import { categoriesOriginal, heCategoriesOriginal } from "../../fixtures/categories";

// Styles & assets
import "./Checklist.css";

// const CATEGORIES_LIST_LOCAL =
//   navigator.language.includes('he') ? heCategoriesOriginal : categoriesOriginal;

const getSelectedMap = memoizeOne((selectedTaskIds) =>
    selectedTaskIds.reduce((previous, current) => {
      previous[current] = true;
      return previous;
    }, {}),
);

const primaryButton = 0;

const keyCodes = {
  enter: 13,
  escape: 27,
  arrowDown: 40,
  arrowUp: 38,
  tab: 9,
};

class InnerQuoteListItem extends React.Component {

  onKeyDown = (event, snapshot) => {
    // already used
    if (event.defaultPrevented) {
      return;
    }

    if (snapshot.isDragging) {
      return;
    }

    if (event.keyCode !== keyCodes.enter) {
      return;
    }

    // we are using the event for selection
    event.preventDefault();

    this.performAction(event);
  };

  // Using onClick as it will be correctly
  // preventing if there was a drag
  onClick = (event) => {
    if (event.defaultPrevented) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    // marking the event as used
    event.preventDefault();

    this.performAction(event);
  };

  // Determines if the platform specific toggle selection in group key was used
  wasToggleInSelectionGroupKeyUsed = (event) => {
    const isUsingWindows = navigator.platform.indexOf('Win') >= 0;
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  // Determines if the multiSelect key was used
  wasMultiSelectKeyUsed = (event) => event.shiftKey;

  performAction = (event) => {
    const {
      task,
      toggleSelection,
      toggleSelectionInGroup,
      multiSelectTo,
      quote,
      column,
      columnId
    } = this.props;

    if (this.wasToggleInSelectionGroupKeyUsed(event)) {
      toggleSelectionInGroup(quote, columnId);
      return;
    }

    // if (this.wasMultiSelectKeyUsed(event)) {
    //   multiSelectTo(quote);
    //   return;
    // }

    // toggleSelection(quote, column);
  };

  render() {
    const {column, quotes, isDropDisabled, quote, selectedTaskIds} = this.props;
    const {dragProvided, dragSnapshot} = this.props;

    let selectedStyles = {};

    if (this.props.isSelected) {
      selectedStyles = {
        borderColor: '#D3D3D3',
        backgroundColor: '#D3D3D3'
      }
    }

    return (
      <div
          ref={dragProvided.innerRef}
          {...dragProvided.dragHandleProps}
          {...dragProvided.draggableProps}
          style={{
            ...dragProvided.draggableProps.style,
            marginBottom: "5px"
          }}
          key={quote}
          onClick={this.onClick}
          onKeyDown={(event) =>
              this.onKeyDown(event, dragSnapshot)
          }
      >
        {column[quote] &&
          <Card style={{padding: "15px", paddingBottom: 0, ...selectedStyles}}>
            {column[quote].section && (
                <div
                    title="Section"
                    className="card-text"
                    style={{fontWeight: "bold"}}
                >
                  {column[quote].section}
                </div>
            )}
            {/* {column[quote].standard && (
                    <div title="Standard" className="card-text">
                      {column[quote].standard}
                    </div>
                  )} */}
            {column[quote].description && (
                <div title="Description" className="card-text">
                  {column[quote].description.length > 90
                      ? column[quote].description.slice(0, 90) + "..."
                      : column[quote].description}
                </div>
            )}
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <div style={{display: "flex"}}>
                {column[quote].isPhotoRequired && <CameraIcon style={{marginTop: 12, color: 'red'}}/> }
                {column[quote].isCommentRequired && <CommentIcon style={{marginTop: 12, color: 'red'}}/> }
              </div>
              <div style={{display: "flex", justifyContent: "flex-end"}}>
                <IconButton disabled={isDropDisabled} onClick={() => {
                  if (!isDropDisabled) {
                    this.props.onEdit(column[quote])
                  }
                }}
                >
                  <EditIcon/>
                </IconButton>
                <IconButton disabled={isDropDisabled} onClick={() => {
                  if (!isDropDisabled) {
                    this.props.onDelete(quote)
                  }
                }}
                >
                  <DeleteIcon/>
                </IconButton>
              </div>
            </div>
          </Card>
      }
      </div>
    );
  }
}

class InnerQuoteList extends React.Component {

  shouldComponentUpdate(nextProps) {
    if (nextProps.quotes !== this.props.quotes) {
      return true;
    }

    if (nextProps.selectedTaskIds.length !== this.props.selectedTaskIds.length) {
      return true;
    }

    return false;
  }

  render() {
    const {column, quotes, isDropDisabled, selectedTaskIds} = this.props;

    return quotes.map((quote, index) => {
      if (!column) {
        console.log('column[quote]', quote, column);
        return null;
      }

      return (
        <Draggable
            key={quote}
            draggableId={quote}
            index={index}
            isDragDisabled={column[quote] && column[quote].disabled}
        >
          {(dragProvided, dragSnapshot) => {
            const isSelected = Boolean(
                getSelectedMap(selectedTaskIds)[quote],
            );

            return (
              <InnerQuoteListItem
                  dragProvided={dragProvided}
                  dragSnapshot={dragSnapshot}
                  quote={quote}
                  quotes={quotes}
                  isDropDisabled={isDropDisabled}
                  column={column}
                  isSelected={isSelected}

                  {...this.props}
              />
            )
          }}
        </Draggable>
    )});
  }
}

class InnerList extends React.Component {
  render() {
    let { quotes, dropProvided, onEdit, onDelete, column, isDropDisabled } = this.props;

    const title = this.props.title ? (
      <div className="title">{this.props.title}</div>
    ) : null;

    return (
      <div>
        {title}
        <div className="drop-zone" ref={dropProvided.innerRef}>
          <InnerQuoteList
            column={column}
            quotes={quotes}
            onEdit={onEdit}
            onDelete={onDelete}
            isDropDisabled={isDropDisabled}

            columnId={this.props.columnId}
            toggleSelectionInGroup={this.props.toggleSelectionInGroup}
            toggleSelection={this.props.toggleSelection}
            selectedTaskIds={this.props.selectedTaskIds}
          />
          {dropProvided.placeholder}
        </div>
      </div>
    );
  }
}

export default class ChecklistGroupItem extends React.Component {
  static defaultProps = {
    listId: "LIST"
  };
  render() {
    const {
      ignoreContainerClipping,
      // internalScroll,
      // scrollContainerStyle,
      isDropDisabled,
      isCombineEnabled,
      listId,
      listType,
      style,
      quotes,
      title,
      onEdit,
      onDelete,
      column
    } = this.props;

    return (
      <Droppable
        droppableId={listId}
        type={listType}
        ignoreContainerClipping={ignoreContainerClipping}
        isDropDisabled={isDropDisabled}
        isCombineEnabled={isCombineEnabled}
      >
        {(dropProvided, dropSnapshot) => (
          <div
            className="wrapper-item"
            style={style}
            {...dropProvided.droppableProps}
          >
            <InnerList
              column={column}
              onEdit={onEdit}
              onDelete={onDelete}
              quotes={quotes}
              title={title}
              dropProvided={dropProvided}
              isDropDisabled={isDropDisabled}

              columnId={this.props.columnId}
              toggleSelectionInGroup={this.props.toggleSelectionInGroup}
              toggleSelection={this.props.toggleSelection}
              selectedTaskIds={this.props.selectedTaskIds}
            />
          </div>
        )}
      </Droppable>
    );
  }
}
